module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAhCAYAAAC4JqlRAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAASBJREFUeNpitIqakcDAwKDAMECABYjjgdhhoBzAxDDAYMAdwEIrg3m42BhU5UUYjLSkwPznrz+D8ZdvPxluP3xLOweALM6PtWLwslPHKn/++jOGnJbNtHEAyPIpNX5AnwsPTBoA+ZwUy6nqAJDvcQU7XRIhKMFhA6AEt+3QTXjCAyVCGjkAe9DntGwCWvqL9lHAy82ONcXjs3y0JKQoDRhqSsFLOQhfEkONhAgvQ3KwCYrYuWvPwFFDsQNAlicFGeNVIynKi1UNsgPoHgWg+mBA08CAO+D2wzfUSYSgxISaKCXBCRPdt9sP30IRQy8XyHYAKCEhJyZQakd3wIs3nxnmrj0zWhCNOmDUAaMOGHXA4HYAo1XUDAMgLTBQDgAIMACrs1rjOi7E7QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/views/SocialView/Facebook.png
// module id = 813
// module chunks = 0